import { gql } from 'apollo-boost';

export const CONFIRMA_PAGINA_SUCESSO = gql`
  mutation confirmaPaginaSucesso {
    confirmaPaginaSucesso
  }
`;
